import { FC, useEffect } from "react";
import { useCookieConsent } from "~context/cookieConsentContext";
import { ENABLE_TRACKING_SCRIPTS } from "~features/tracking/trackingConfig";

interface GoogleTagManagerScriptProps {
  containerId?: string;
}

const FIXED_GTM_CONTAINERS = ["GTM-WXVNCRX", "GTM-MSK3NHN"];

export const GoogleTagManagerScript: FC<GoogleTagManagerScriptProps> = ({
  containerId,
}) => {
  const { isAnalyticsAllowed } = useCookieConsent();

  useEffect(() => {
    if (ENABLE_TRACKING_SCRIPTS && !!containerId && isAnalyticsAllowed()) {
      (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
        const f = d.getElementsByTagName(s)[0],
          j: any = d.createElement(s),
          dl = l !== "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.defer = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "dataLayer", containerId);
    }
  }, [containerId, isAnalyticsAllowed]);

  return null;
};

export const FixedGoogleTagManagerScripts: React.FC = () => {
  return (
    <>
      {FIXED_GTM_CONTAINERS.map((containerId) => (
        <GoogleTagManagerScript key={containerId} containerId={containerId} />
      ))}
    </>
  );
};
